import { Injectable, inject } from '@angular/core';

import { Store } from '@ngrx/store';

import {
  LoggedUser,
  User,
  UserOptions,
} from '@personal-area/global/users/models';

import { GetUser, UpdateUser, UpdateUserExtras, UpdateUserOptions } from '../actions/user';
import { UserState, initialState } from '../reducers/user';
import {
  getGeoLocation,
  getUser,
  getUserCountry,
  getUserRole,
  isUserLoaded,
} from '../selectors/user';
import { UserExtras } from '@personal-area/users';
import { filter, map, withLatestFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserFacade {
  private _store = inject(Store<UserState>);

  public user$ = this._store.select(getUser);
  public userRole$ = this._store.select(getUserRole);
  public userCountry$ = this._store.select(getUserCountry);
  public geoLocation$ = this._store.select(getGeoLocation); // country by X-User-Location header
  public isUserLoaded$ = this._store.select(isUserLoaded);

  public loggedUser$ = this.user$.pipe(
    withLatestFrom(this.isUserLoaded$),
    filter(([, isLoaded]) => isLoaded),
    map(([user]) => user),
  );

  private _loggedUser = initialState.user;

  constructor() {
    this.user$.subscribe((user) => (this._loggedUser = user));
  }

  /*
   * @deprecated
   * Use user$ instead
   */
  public get loggedUser(): LoggedUser {
    return this._loggedUser;
  }

  public getUser(userId: number): void {
    this._store.dispatch(GetUser(userId));
  }

  public updateUser(user: Partial<User>): void {
    this._store.dispatch(UpdateUser(user));
  }

  public updateUserOptions(options: Partial<UserOptions>): void {
    this._store.dispatch(UpdateUserOptions(options));
  }

  public updateUserExtras(extras: Partial<UserExtras>): void {
    this._store.dispatch(UpdateUserExtras(extras))
  }
}
